"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyle = exports.InstanceFooters = void 0;
// @ts-nocheck
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const react_1 = __importStar(require("react"));
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const RepeatWrapperWeb_1 = require("./RepeatWrapperWeb");
const theme_1 = require("../../styles/theme");
const common_1 = require("../../utils/common");
const RepeatFieldWrapperWeb = props => {
    const { controlDefinition, onRemoveClick, repeatCount, isOriginal } = props;
    const { openDeleteConfirmation } = RepeatWrapperWeb_1.useRepeatWrapperContext();
    const classes = exports.useStyle();
    const canDelete = react_1.useCallback(() => {
        if (isOriginal && !FormRendererHelpers_1.getAllowInitialDataDelete(controlDefinition)) {
            return false;
        }
        return repeatCount > FormRendererHelpers_1.getRepeatMin(controlDefinition);
    }, [repeatCount, controlDefinition, isOriginal]);
    return (react_1.default.createElement("div", { style: styles.root },
        react_1.default.createElement("div", { className: classes.fieldWrapper },
            props.children,
            canDelete() && (react_1.default.createElement(core_1.Button, { size: 'small', style: styles.deleteButton, variant: 'text', onClick: () => {
                    openDeleteConfirmation(onRemoveClick, FormRendererHelpers_1.getDeleteConfirmationMessage(controlDefinition));
                } }, "Delete"))),
        react_1.default.createElement(exports.InstanceFooters, Object.assign({}, props))));
};
const InstanceInfo = ({ label, value }) => (react_1.default.createElement("div", { style: styles.innerStyle },
    react_1.default.createElement("span", { style: styles.labelStyle }, label),
    react_1.default.createElement("span", { style: styles.valueStyle }, `: ${value}`)));
const InstanceFooters = (props) => {
    const { repeatCount, index, controlDefinition, onAddClick } = props;
    const classes = exports.useStyle();
    const canDelete = react_1.useCallback(() => {
        return repeatCount === index + 1 && FormRendererHelpers_1.getRepeatsEnabled(controlDefinition);
    }, [repeatCount, index, controlDefinition]);
    const repeatMax = react_1.useMemo(() => {
        return FormRendererHelpers_1.getRepeatMax(controlDefinition);
    }, [controlDefinition]);
    const canAddItem = react_1.useCallback(() => {
        if (!FormRendererHelpers_1.getAllowAdding(controlDefinition)) {
            return false;
        }
        const repeatMaxSetting = FormRendererHelpers_1.getRepeatMax(controlDefinition);
        return repeatMaxSetting === -1 || repeatCount < repeatMaxSetting;
    }, [repeatCount, controlDefinition]);
    return canDelete() ? (react_1.default.createElement("div", { style: styles.deleteContainer },
        react_1.default.createElement("div", { className: classes.countContainerStyle },
            react_1.default.createElement(InstanceInfo, { label: "Instances", value: repeatCount }),
            react_1.default.createElement(InstanceInfo, { label: "Required", value: FormRendererHelpers_1.getRepeatMin(controlDefinition) }),
            react_1.default.createElement(InstanceInfo, { label: "Allowed", value: repeatMax === -1 ? 'unlimited' : repeatMax })),
        canAddItem() && (react_1.default.createElement(core_1.Button, { size: 'small', onClick: () => {
                onAddClick();
            }, color: 'primary', className: classes.button }, FormRendererHelpers_1.getAddButtonText(controlDefinition))))) : null;
};
exports.InstanceFooters = InstanceFooters;
exports.useStyle = styles_1.makeStyles(theme => ({
    fieldWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottom: `1px solid ${theme_1.colors.black10}`,
        padding: '18px 20px',
        justifyContent: 'space-between',
        gap: 5,
        '& div': {
            border: 'none !important',
            padding: '0px !important',
            width: '100%',
        },
    },
    repeatDetails: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    repeatMenu: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    instanceInfo: {
        fontWeight: 500,
    },
    handle: {
        display: 'flex',
        width: 25,
        alignItems: 'center',
        '& img': {
            width: 13,
            height: 21,
            marginRight: '.3em',
        },
        '& span': {
            color: theme_1.colors.title,
        },
    },
    button: {
        fontSize: 13,
        fontWeight: 500,
        textTransform: 'capitalize',
    },
    countContainerStyle: {
        display: 'flex',
        fontSize: '13px',
        fontWeight: 400,
        gap: '10px',
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            flexDirection: 'column',
            gap: 6,
        },
    },
}));
const styles = {
    root: {
        flexDirection: 'column',
    },
    deleteButton: {
        color: theme_1.colors.darkRed,
        padding: 0,
        display: 'flex',
        justifyContent: 'end',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: 'normal',
        textTransform: 'capitalize',
        minWidth: 0,
        '&:hover': {
            background: 'none',
        },
    },
    deleteContainer: {
        backgroundColor: theme_1.colors.lotion,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
    },
    countContainer: {
        display: 'flex',
        fontSize: '13px',
        fontWeight: 400,
    },
    labelStyle: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
    },
    valueStyle: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
    innerStyle: {
        display: 'flex',
    },
    seprator: {
        marginRight: 2,
    },
};
exports.default = RepeatFieldWrapperWeb;
//# sourceMappingURL=RepeatFieldWrapperWeb.js.map